import type { ESerpTypes } from "app/common/serp/SerpFilterMaps";
import { keywordsReportTableFiltersMap, type KeywordsReportTableFilter } from "../CampaignsConst";

import { isPaidExcludedFromPosition } from "./isPaidExcludedFromPosition";
import { isUnifiedPositionEnabled } from "./isUnifiedPositionEnabled";

export const sanitizeUseCaseFilter = (
    filter?: string | null,
    positionExcludedSerpFeatures?: readonly ESerpTypes[] | null,
): KeywordsReportTableFilter | undefined => {
    if (!filter) {
        return undefined;
    }
    if (!Object.values(keywordsReportTableFiltersMap).includes(filter as KeywordsReportTableFilter)) {
        return undefined;
    }

    const typedFilter = filter as KeywordsReportTableFilter;
    if (isUnifiedPositionEnabled()) {
        if (typedFilter === keywordsReportTableFiltersMap.ORGANIC_CANNIBALIZATION) {
            return undefined;
        }
        if (
            typedFilter === keywordsReportTableFiltersMap.PAID_CANNIBALIZATION &&
            !isPaidExcludedFromPosition(positionExcludedSerpFeatures)
        ) {
            return undefined;
        }
    } else if (typedFilter === keywordsReportTableFiltersMap.AIO_CITATION) {
        return undefined;
    }

    return typedFilter;
};
